<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.show service provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div>
            <label style="color: #405950; font-size: 16px" class="mb-5">{{
              $t("PLACEHOLDERS.logo")
            }}</label>
          </div>
          <div class="image-wrapper">
            <div class="image-preview">
              <img loading="lazy" :src="data.media?.path" alt="photo" />
            </div>
          </div>
          <!-- End:: Image Upload Input -->
          <!-- Start:: Image Upload Input -->
          <div>
            <div>
              <label style="color: #405950; font-size: 16px" class="mt-5">{{
                $t("PLACEHOLDERS.addImgs")
              }}</label>
            </div>
            <img
              v-for="img in AddimgUrls"
              :src="img"
              style="max-width: 150px; cursor: pointer"
              class="mx-5 my-3"
              @click="showImageModal(img)"
            />
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Inputs -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.storeTitleAr')"
            v-model.trim="data.nameAr"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.storeTitleEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Inputs -->

          <!-- Start:: Description Inputs -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descProdEn"
            disabled
          />
          <!-- End:: Description Inputs -->

          <!-- Start:: Store Input -->
          <base-select-input
            col="6"
            :optionsList="sections"
            :placeholder="$t('PLACEHOLDERS.section')"
            v-model="data.section_id"
            disabled
          />

          <base-select-input
            col="6"
            :optionsList="distinctiveMarks"
            :placeholder="
              $t('MESSAGES.Distinctive mark of the service provider')
            "
            v-model="data.featured_tag"
            disabled
          />

          <ChangableMapComponent
            :lat="parseFloat(data.lat)"
            :lng="parseFloat(data.lng)"
            @update:lat="data.lat = $event"
            @update:lng="data.lng = $event"
          />
          <div class="row justify-content-center mt-3">
            <h4>{{ $t("PLACEHOLDERS.contacts") }}</h4>
            <div class="col-l2"></div>
            <div
              class="col-lg-6 col-12"
              v-for="(item, index) in data.phone_numbers"
              :key="'l' + index"
            >
              <div class="item d-flex align-items-center">
                <base-input
                  class="w-100"
                  type="tel"
                  :placeholder="$t('PLACEHOLDERS.phone')"
                  v-model.trim="item.phone"
                  disabled
                />
              </div>
            </div>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.whatsapp_number"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.social_media_links.facebook"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.social_media_links.instagram"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snapchat')"
            v-model.trim="data.social_media_links.snapchat"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.twitter_link')"
            v-model.trim="data.social_media_links.x"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok')"
            v-model.trim="data.social_media_links.tiktok"
            disabled
          />
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              disabled
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
    <template>
      <!-- Start:: Image Modal -->
      <image-modal
        v-if="dialogImage"
        :type="selectedItemType"
        :modalIsOpen="dialogImage"
        :modalImage="selectedItemImage"
        @toggleModal="dialogImage = !dialogImage"
      />
    </template>
  </div>
</template>

<script>
import BaseMultiImageUploadInput from "../../../components/formInputs/BaseMultiImageUploadInput.vue";
import BaseNamePreviewFileUploadInput from "../../../components/formInputs/BaseNamePreviewFileUploadInput.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "CreateProviders",

  components: {
    BaseMultiImageUploadInput,
    BaseNamePreviewFileUploadInput,
    ChangableMapComponent,
  },

  data() {
    return {
      dialogImage: false,
      selectedItemImage: null,
      isWaitingRequest: false,
      sections: [],
      store: null,
      store_waiting: null,
      file: null,
      fileType: "",
      AddimgUrls: [],
      files: [],
      additionalImages: [],
      imageId: [],
      imgUrls: [],
      data: {
        section_id: null,
        media: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        lat: 0,
        lng: 0,
        whatsapp_number: true,
        phone_numbers: [],
        social_media_links: {
          facebook: null,
          instagram: null,
          tiktok: null,
          x: null,
          snapchat: null,
        },
        active: true,
        featured_tag: null,
        AddimgUrls: [],
        additionalImages: [],
        imageId: [],
        imgUrls: [],
      },
      dropdownOptions: {},
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  computed: {
    distinctiveMarks() {
      return [
        {
          id: "new",
          name: this.$t("PLACEHOLDERS.new"),
        },
        {
          id: "trendy",
          name: this.$t("MESSAGES.trendy"),
        },
        {
          id: "most_popular",
          name: this.$t("MESSAGES.most_popular"),
        },
        {
          id: "opened",
          name: this.$t("MESSAGES.opened"),
        },
        {
          id: "soon",
          name: this.$t("MESSAGES.soon"),
        },
        {
          id: "most_visited",
          name: this.$t("MESSAGES.most_visited"),
        },
        {
          id: "available_24_hours",
          name: this.$t("PLACEHOLDERS.available_24_hours"),
        },
        {
          id: "friday_hospitality",
          name: this.$t("PLACEHOLDERS.friday_hospitality"),
        },
      ];
    },
  },
  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },
    onFileSelectField(files) {
      this.data.additionalImages = files;
    },
    onFileRemoveField(index) {
      this.$delete(this.data.imgUrls, index);
    },
    async getStoreData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params?.id}`,
        });
        this.data.nameAr = res.data.data.Provider.name_ar;
        this.data.nameEn = res.data.data.Provider.name_en;
        this.data.descProd = res.data.data.Provider.description_ar;
        this.data.descProdEn = res.data.data.Provider.description_en;
        this.data.media.path = res.data.data.Provider.logo;
        this.data.section_id = res.data.data.Provider.category_id;
        this.data.lat = res.data.data.Provider.lat;
        this.data.active = res.data.data.Provider.is_active;
        this.data.lng = res.data.data.Provider.lng;
        this.AddimgUrls =
          res.data.data.Provider.gallery &&
          res.data.data.Provider.gallery.map((item) => item.url);
        this.imageId = res.data.data.Provider.gallery.map((item) => item?.id);

        this.data.whatsapp_number = res.data.data.Provider.whatsapp_number;
        if (res.data.data.Provider.phone_numbers) {
          let phones = res.data.data.Provider.phone_numbers;
          this.data.phone_numbers = phones.map((item) => {
            return { phone: item };
          });
        }
        // this.data.phone_numbers = res.data.data.Provider.phone_numbers;
        this.data.social_media_links =
          res.data.data.Provider.social_media_links;
        this.data.featured_tag = this.distinctiveMarks.find((item) => {
          return item.id === res.data.data.Provider.featured_tag;
        });

        this.data.featured_tag = this.distinctiveMarks.find((item) => {
          return item.id === res.data.data.Provider.featured_tag;
        });
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getSections() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "categories?page=0&limit=0&is_active=1",
        });
        this.sections = res.data.data.data;
        this.store_waiting = "done";
      } catch (error) {
        this.store_waiting = "done";
        console.log(error.response.data.message);
      }
    },
    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemImage = item;
      this.selectedItemType = item.endsWith("mp4") ? "video" : "image";
    },
  },
  created() {
    this.getStoreData();
    this.getSections();
  },
};
</script>
<style>
.image-wrapper {
  max-width: 100%;
  overflow-x: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-inline: 10px;
}

.image-wrapper .image-preview {
  position: relative;
  transition: all 1s ease;
  overflow: hidden;
}

.image-wrapper img {
  border-radius: 8px;
  max-width: 400px;
  max-height: 400px;
}
</style>
